// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__2mgZd","text":"TermsAndConditions_text__2EW4M"};